import { getAccessToken } from '@api/semrush/integration.api';
import { loginFromSemrush } from '@api/auth.api';
import { authService } from 'src/services/authService';
import { isInternalPage } from '@utils/redirections';
import { getAppBillingShortDetailsApi } from '@api/billing-app.api';
import { isSemrushMode } from '@constants/app-modes';
import { isConciergeRealm, isPublisherRealm } from '@utils/realmIdentifier';
import { getItemFromStorage } from '@utils/localStorageHandler';

declare const IS_LOCAL: boolean;

export const checkLoggedIn = async (history: History): Promise<boolean> => {
  if (isSemrushMode()) {
    try {
      const jwtToken = await getAccessToken();
      const password = IS_LOCAL ? 'hardcoded_password' : undefined;

      const result = await loginFromSemrush(jwtToken, password);

      if (!isInternalPage(window.location.pathname)) {
        authService.loginCallback(history, result);
      }

      return true;
    } catch (error) {
      console.error('Authentication error:', error);
      return false;
    }
  } else {
    const token = getItemFromStorage('token');

    if (token === undefined) {
      return false;
    }

    const response =
      isConciergeRealm() || isPublisherRealm() ? true : await getAppBillingShortDetailsApi(false);

    return response != null;
  }
};
